import { RoleEnum } from "./RoleEnum";
export var PV_READ_ROLES = [
    RoleEnum.ADMIN_LEGAL_DEPOSITS,
    RoleEnum.LIBRARIAN_LEGAL_DEPOSITS,
    RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
    RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
];
export var LIBRARY_WRITE_ROLES = [RoleEnum.ADMIN_LEGAL_DEPOSITS];
export var PUBLISHER_WRITE_ROLES = [
    RoleEnum.ADMIN_LEGAL_DEPOSITS,
    RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
    RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
];
